@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

button.dropdownButton {
  @include md-sohne;
  @include transition;
  color: var(--dark-100);
  cursor: pointer;
  height: 40px;
  gap: 2px;
  display: inline-flex;
  border-radius: 20px;
  padding: 8px;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    height: 32px;
    border-radius: 8px;
    padding: 8px;
  }

  &.chevronButton {
    @include md-sohne;
    color: var(--dark-100);
    width: auto;
    padding: 10px;

    [data-autopilot-system-redesign='on'] & {
      @include sm-sohne;
      height: 32px;
      border-radius: 8px;
      padding: 8px;
    }
  }

  &:hover {
    background-color: var(--neutral-5);

    [data-autopilot-system-redesign='on'] & {
      background-color: var(--dark-4);
    }
  }

  &.isOpen {
    background: var(--dark-4);
    box-shadow: 0px 5px 10px 0px var(--light-5);

    &.isSubmenu {
      @include blur;
      background: var(--dark-4);
    }
  }

  &.active {
    background-color: var(--focus-5);
    color: var(--focus-50);
  }

  &.isSubmenu {
    @include md-medium;
    color: var(--neutral-90);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    padding: 8px;

    &:hover {
      @include blur;
      background: var(--dark-4);
    }
  }

  &.active {
    color: var(--dark-100);
    background: linear-gradient(0deg, var(--dark-7) 0%, var(--dark-7) 100%), var(--dark-7);
  }
}

.dropdownBody {
  @include fadein;
  @include blur;
  @include z-index(tooltip);
  display: flex;
  position: absolute;
  background: var(--light-60);
  border-radius: 6px;
  box-shadow: 0.5px 0.5px 0 0 var(--light-100) inset, 0 6px 32px 0px rgba(0, 0, 0, 0.15);
  padding: 4px;
  gap: 2px;
}

.dropdownBodyVertical {
  flex-direction: column;
}

.item {
  width: 100%;
  display: flex;
  gap: 6px;
  align-items: center;

  svg {
    color: var(--dark-100);
  }
}

.chevron {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.chevronLabel {
  @include md-regular;
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 6px;
  color: var(--neutral-30);

  svg {
    color: var(--neutral-30);
  }
}
